import React from 'react';
import { Box } from '@mui/material';
import { permissionService } from '../../services/permissionService';
import { RoleType } from '../../models/enums/roleType';
import { DispatcherHome } from './DispatcherHome';
import { MedicHome } from './MedicHome';
import { HomeHeader } from './HomeHeader';
import { AdminHome } from './AdminHome';

export const Home: React.FC = () => {
    const roles = permissionService.getRoles();
    const isMedic = roles.includes(RoleType.Medic);
    const isDispatcher = roles.includes(RoleType.Dispatcher);
    const isAdmin = roles.includes(RoleType.Admin);

    return (
        <Box>
            <HomeHeader />

            {/* Если пользователь медик, показываем компонент для медика */}
            {isMedic && <MedicHome />}

            {/* Если пользователь диспетчер, показываем компонент для диспетчера */}
            {!isMedic && isDispatcher && <DispatcherHome />}

            {!isMedic && !isDispatcher && isAdmin && <AdminHome />}
        </Box>
    );
};
